<template>
  <div class="text-weight-bold" v-if="campoVisivel">
    <div class="titulo-input">Local de Depósito*</div>
    <q-select
      v-model="deposito"
      :options="options"
      class="input-mobile"
      option-label="nome"
      option-value="depositoLocalUuid"
      dense
      use-input
      map-options
      outlined
      label="Selecione o Depósito"
      label-color="grey-6"
      behavior="menu"
      @filter="filtrarDeposito"
    />
  </div>
</template>

<script>
import { onMounted, ref, watch } from "vue";
import { useStore } from "vuex";

export default {
  emits: ["enviarDeposito"],
  props: ["resetar", "model", "autoSelecionar", "unidadeId"],
  setup(props, { emit }) {
    const store = useStore();

    const deposito = ref(props.model);
    const options = ref([]);
    let campoVisivel = ref(false);

    const listarDeposito = async (val) => {
      const array = [];
      await store.state.org.unidadeData.id;
      try {
        const response = await store.dispatch("ferramentaria/listarDeposito", {
          unidadeId: props.unidadeId || store.state.org.unidadeData.id,
        });
        response.data.resultado.dados.forEach((deposito) => {
          if (deposito.locais.length > 0) {
            deposito.locais.forEach((value) => {
              array.push({
                nome: value.local,
                depositoLocalUuid: value.depositoLocalUuid,
              });
            });
          }
        });
        options.value = array.filter((value) => {
          return value.nome
            .trim()
            .toLowerCase()
            .includes(val?.trim().toLowerCase());
        });
      } catch (error) {
        console.log(error);
      }
    };

    const selecionarDeposito = async () => {
      await store.state.org.unidadeData.id;
      const array = [];
      try {
        const response = await store.dispatch("ferramentaria/listarDeposito", {
          unidadeId: props.unidadeId || store.state.org.unidadeData.id,
        });
        response.data.resultado.dados.forEach((deposito) => {
          if (deposito.locais.length > 0) {
            deposito.locais.forEach((value) => {
              array.push({
                nome: value.local,
                depositoLocalUuid: value.depositoLocalUuid,
              });
            });
          }
        });
        deposito.value = array[0];
        if (array.length > 1) {
          campoVisivel.value = true;
          return;
        }
      } catch (error) {
        console.log(error);
      }
    };

    watch(
      () => deposito.value,
      () => {
        emit("enviarDeposito", deposito.value);
      }
    );

    watch(
      () => props.model,
      () => {
        deposito.value = props.model;
      }
    );

    watch(
      () => props.resetar,
      () => {
        deposito.value = "";
      }
    );

    watch(
      () => store.state.org.unidadeData.id,
      () => {
        if (
          props.autoSelecionar === true ||
          props.autoSelecionar === undefined
        ) {
          selecionarDeposito();
          return;
        }
      }
    );

    onMounted(() => {
      if (props.model != "" && props.model != undefined) {
        campoVisivel.value = true;
        return;
      }
      if (props.autoSelecionar === true || props.autoSelecionar === undefined) {
        selecionarDeposito();
        return;
      }
      campoVisivel.value = true;
    });

    return {
      deposito,
      campoVisivel,
      listarDeposito,
      selecionarDeposito,
      options,
      filtrarDeposito(val, update) {
        listarDeposito(val);
        setTimeout(() => {
          update();
        }, 500);
      },
    };
  },
};
</script>

<style scoped>
@media (max-width: 600px) {
  .input-mobile {
    font-size: 12px;
  }
  .titulo-input {
    font-size: 12px;
  }
}
</style>
